/* import __COLOCATED_TEMPLATE__ from './logs.hbs'; */
/* RESPONSIBLE TEAM: team-actions */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class Logs extends Component {
  @tracked selectedAction;
  @tracked _hasAutoSelected = false; // Flag to prevent multiple auto-selections
  @tracked filters = {
    success: 'any',
    error_type: 'any',
    created_at: 168,
    id: 'any',
    conversation_id: 'any',
  };

  constructor() {
    super(...arguments);

    // If actionExecutionResultId is provided, try to find and select that specific action
    if (this.args.actionExecutionResultId) {
      let specificAction = this.args.workflowActionLogs.find(
        (action) => action.id === this.args.actionExecutionResultId,
      );
      this.selectedAction = specificAction || this.args.workflowActionLogs.objectAt(0);

      // Also set the filter to this specific ID
      this.filters.id = this.args.actionExecutionResultId.toString();
      return;
    }

    // Auto-select the first action if there's only one
    if (this.args.workflowActionLogs.length === 1) {
      this.selectedAction = this.args.workflowActionLogs.objectAt(0);
    }
  }

  @action
  onNewFilterSelected(key, selectedValues) {
    this.filters[key] = selectedValues;
    this.args.updateFilters(this.filters);

    // Reset auto-selection flag when filters change so it can auto-select again
    this._hasAutoSelected = false;

    // After filtering, auto-select if only one result
    // Use setTimeout to avoid reactive cycles
    setTimeout(() => {
      if (this.args.workflowActionLogs.length === 1) {
        this.selectedAction = this.args.workflowActionLogs.objectAt(0);
      } else if (this.args.workflowActionLogs.length === 0) {
        this.selectedAction = null;
      }
    }, 0);
  }

  @action
  checkForAutoSelection() {
    // Only try auto-selection if we haven't done it yet and logs are available
    if (
      !this._hasAutoSelected &&
      this.args.workflowActionLogs &&
      this.args.workflowActionLogs.length > 0
    ) {
      this._performAutoSelection();
      this._hasAutoSelected = true;
    }
  }

  _performAutoSelection() {
    // If actionExecutionResultId is provided, try to find and select that specific action
    if (this.args.actionExecutionResultId) {
      let specificAction = this.args.workflowActionLogs.find(
        (action) => action.id === this.args.actionExecutionResultId,
      );
      if (specificAction) {
        this.selectedAction = specificAction;
        return;
      }
    }

    // Auto-select the first action if there's only one
    if (this.args.workflowActionLogs.length === 1) {
      this.selectedAction = this.args.workflowActionLogs.objectAt(0);
    }
  }
}
